import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'state-preview',
  styleUrls: ['./state.preview.component.scss'],
  template: `  <div class="state-preview">
  <svg x="0" y="0" width="100%" height="100%" viewBox="0 0 200 100">
    <line
      [attr.x1]="0"
      [attr.y1]="50"
      [attr.x2]="200"
      [attr.y2]="50"
      class="connection"
    />
    <circle
      class="end-point"
      cx="3"
      cy="50"
      r="3"
      class="end-point"
    ></circle>
    <circle
      class="end-point"
      cx="197"
      cy="50"
      r="3"
      class="end-point"
    ></circle>
  </svg>
</div>`
})
export class StatePreviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
